// CAROUSEL WITH autoplay
(function ($) {
    $(document).on('ready', function () {
        animationMainContent();
        copyClassesBreadcrumb();
    });

    function animationMainContent() {
        if (globalVar.is_desktop) {
            let mainContents = $('[id^="main-content"]');
            mainContents.each(function () {
                const bigImage = $(this).find('.featured_img .thumb_wrap');

                if (bigImage !== 0) {
                    let tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: $(this),
                            start: "top 20%",
                            end: "bottom bottom",
                            scrub: true,
                            pin: bigImage
                        },
                    });
                }
            });
        }
    }

    function copyClassesBreadcrumb() {
        if ($('#breadcrumb').length !== 0 && $('#main-content-1').length !== 0) {
            let classlistMain = $('#main-content-1').attr("class");
            let classlistBread = $('#breadcrumb').attr("class");
            let classlistBreadFixed = classlistBread.replace(/hidden-/g,'');

            const totalClasses = classlistMain + ' ' + classlistBreadFixed;
            console.log('classes main content', classlistMain);
            console.log('classes bread', classlistBread);
            $('#main-content-1').attr("class", totalClasses);
        }
    }
}(jQuery));
